"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.FontSizeSetting = void 0;
var _CallAPI = require("01_core/components/system/CallAPI");
var _CodeUtil = require("01_core/components/system/CodeUtil");
var _APIs = require("01_core/constants/APIs");
var _CodeConsts = require("01_core/constants/CodeConsts");
var _labelConsts = require("01_core/constants/labelConsts");
var _coreFontActions = require("01_core/reducers/coreFontActions");
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _SimpleSettingDialog = _interopRequireDefault(require("../common/components/SimpleSettingDialog"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const FontSizeSetting = function (props) {
  const {
    callAPI,
    getCodeName,
    fontsizeCd,
    open,
    handleClose,
    setFontsize
  } = props;
  const changeFontsize = value => {
    const prevFontsizeCd = fontsizeCd;
    if (prevFontsizeCd !== value) {
      callAPI(_APIs.UPDATE_FONTSIZE, {
        fontsizeCd: value
      }).then(response => {
        if (response.status === _APIs.STATUS.SUCCESS) {
          setFontsize(value);
        } else {
          setFontsize(prevFontsizeCd);
        }
      });
    }
  };
  const fontsizeItems = [{
    displayName: getCodeName(_CodeConsts.CODE.FONTSIZE_CD.KBN, _CodeConsts.CODE.FONTSIZE_CD.CODE_0),
    value: _CodeConsts.CODE.FONTSIZE_CD.CODE_0
  }, {
    displayName: getCodeName(_CodeConsts.CODE.FONTSIZE_CD.KBN, _CodeConsts.CODE.FONTSIZE_CD.CODE_1),
    value: _CodeConsts.CODE.FONTSIZE_CD.CODE_1
  }];
  return /*#__PURE__*/_react.default.createElement(_SimpleSettingDialog.default, {
    open: open,
    onChange: changeFontsize,
    handleClose: handleClose,
    value: fontsizeCd,
    titleId: _labelConsts.LABEL.CORE_FONT_SIZE,
    items: fontsizeItems
  });
};
exports.FontSizeSetting = FontSizeSetting;
const mapStateToProps = state => {
  return {
    fontsizeCd: state.coreFont.fontsizeCd
  };
};
const mapDispatchToProps = dispatch => {
  return {
    setFontsize: fontsizeCd => dispatch(_coreFontActions.coreFontActions[_coreFontActions.TYPES_FONT.SET_FONTSIZE](fontsizeCd))
  };
};
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _CodeUtil.withCodeUtil)((0, _CallAPI.withCallAPI)(FontSizeSetting)));